module.exports = __webpack_public_path__ + "04_glasses_red.e592ef00.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/04_glasses_red.png
// module id = G2lL
// module chunks = 0